import {
  BoardType,
  BoardViewType,
  IBoard,
  PriorityFilterEnum,
} from "app/types";

export interface ISelectedTickets {
  group: string[];
  id: string[];
  status: string[];
  assignee: string[];
  releases: [];
  sprint: [];
  effortsEstimation: number;
}

export interface IFileType {
  id: string;
  name: string;
  type: string;
}

export interface IDueDate {
  startDate: string;
  endDate: string;
}
export interface IDraftTicket {
  id: string;
  name: string;
}
export interface Board {
  _id: string;
  type: BoardType;
  name: string;
  projects: Project[];
  owner: Owner;
  viewType: BoardViewType;
  createdAt: string;
  lastUpdated: string;
  lastViewed: string;
  permission: BoardPermission;
  favorite: number;
}

export interface IBoardForm {
  id: string;
  type: BoardViewType;
  name: string;
  projects: Project[];
  owner: Owner;
  createdAt: string;
  lastUpdated: string;
  lastViewed: string;
  permission: BoardPermission;
  description: string;
  ticketType: TicketType;
  groupsBy: GroupByTypeEnum;
  subGroups: SubGroupEnum;
  visibleGroups: IVisibleGroups[];
  customizeCard: IVisibleGroups[];
  defaultTicketValue: IDefaultTicketValue[];
  customPermissions: ICustomPermissions[];
}

export interface ICustomPermissions {
  id: string;
  access: CustomAccessEnum;
}
export interface IDefaultTicketValue {
  data?: IVisibleGroups;
  id: string;
  value: string;
  type: DefaultTicketType;
}
export enum DefaultTicketType {
  "CUSTOM_FIELDS" = "customFields",
  "CONTEXT_FIELD" = "contextFields",
}
export interface IDefaultTicketValueData {
  customFields: IVisibleGroups[];
  contextFields: IVisibleGroups[];
}
export interface IVisibleGroups {
  id: number | string;
  label: string;
  color?: string;
  className?: string;
  icon?: React.ReactNode;
  isVisible?: boolean;
  type?: GroupByTypeEnum;
  key?: string;
}

export enum BoardPermission {
  PRIVATE = "private",
  PUBLIC = "public",
  CUSTOM = "custom",
}
export enum CustomAccessEnum {
  NONE = "none",
  VIEW_ONLY = "viewOnly",
  FULL_ACCESS = "fullAccess",
  DELETE = "delete",
}

export enum SubMenuTypeEnum {
  GROUP_BY = "groupBy",
  CUSTOMIZE_CARD = "customizeCard",
  BOARD_VIEW = "boardView",
  MORE_DETAILS = "moreDetails",
  TICKET_TYPE = "ticketTypeSelection",
  ARCHIVE = "archive",
  SUB_GROUPS = "subGroups",
  VISIBLE_GROUP = "visibleGroups",
  DEFAULT_TICKET_VALUE = "defaultTicketValue",
  SHARING_PERMISSIONS = "sharingPermissions",
  SAVE_BUTTON = "saveButton",
  REVERT_CHANGES = "revertChanges",
  EXPORT = "export",
}
export interface Project {
  id: string;
  projectName: string;
  color: string;
}

export interface Owner {
  _id: string;
  name: string;
  online: boolean;
  color: string;
  role: string;
}

export enum TicketType {
  TASK = "task",
  BUG = "bug",
  STORY = "story",
  EPIC = "epic",
}
export enum RelationType {
  BLOCKED_BY = "blockedBy",
  BLOCKS = "blocks",
  DUPLICATE = "duplicate",
}
export enum SubGroupEnum {
  NONE = "None",
  ASSIGNEE = "assignee",
  PRIORITY = "priority",
  TAGS = "tags",
  DUE_DATE = "dueDate",
  EPIC = "epic",
}
export enum GroupByTypeEnum {
  NONE = "none",
  TICKET_NAME = "ticketName",
  TICKET_ID = "ticketId",
  STATUS = "status",
  TAGS = "tags",
  EPIC = "epic",
  ASSIGNEE = "assignedTo",
  TICKET_TYPE = "type",
  DUE_DATE = "dueDate",
  PRIORITY = "priority",
  SPRINT = "sprint",
  RELEASE = "release",
  TARGET_RELEASE = "targetRelease",
  ENVIRONMENT = "environment",
  SEVERITY = "severity",
  COMPONENT = "component",
  CREATOR = "createdBy",
  CREATED_DATE = "createdAt",
  EFFORTS_ESTIMATION = "effortEstimated",
  EFFORT_ACTUAL = "effortActual",
  CUSTOM_TITLES = "customTitles",
}
export enum TicketValueEnum {
  TICKET_NAME = "ticketName",
  STATUS = "status",
  ASSIGNEE = "assignee",
  DUE_DATE = "dueDate",
  PRIORITY = "priority",
  TAGS = "tags",
  TICKET_DESCRIPTION = "ticketDescription",
  COMMENT = "comment",
  NOTES = "notes",
  CUSTOM_PRIORITY = "customPriority",
  CREATED_DATE = "createdDate",
  NUMBER = "number",
  ID = "id",
  URL = "url",
}

export interface Project {
  id: string;
  projectName: string;
  color: string;
}
export interface Label {
  id?: string;
  name: string;
  color: string;
  backgroundColor: string;
}

export interface TicketHeader {
  name: string;
  id: string;
  className: string;
}

export enum SprintStatus {
  CURRENT = "current",
  PREVIOUS = "previous",
  NEXT = "next",
}

export type ContainerState = BoardsState;

export enum FilterPickerType {
  CHECKBOX = "checkbox",
  STATUS = "status",
  TAGS = "tags",
  DATE_RANGE = "dateRange",
}

export interface FilterOptionItem {
  id: string;
  label: string;
  color?: string;
}

export type DateRangeFilterValue = {
  startDate: string | null;
  endDate: string | null;
};

export type FilterSelectedValue = string[] | DateRangeFilterValue;

export interface Filter {
  id: string;
  name: string;
  icon: React.ReactNode;
  options: FilterOptionItem[];
  isSearchable: boolean;
  pickerType: FilterPickerType;
}
export enum TicketStatus {
  OPENED = "opened",
  IN_PROCESS = "in process",
  DUPLICATED = "duplicated",
  CLOSED = "closed",
}

export interface IPriority {
  label: PriorityFilterEnum;
  value: PriorityFilterEnum;
  icon: React.ReactNode;
  color: string;
  _id?: string;
}
export enum TicketPriorities {
  NORMAL = "Normal",
  HIGH = "High",
  URGENT = "Urgent",
  LOW = "Low",
}
export enum GroupAction {
  COLLAPSE = "collapse",
  UN_COLLAPSE = "unCollapse",
  SELECT_ALL = "select_all",
  Un_SELECT_ALL = "unselect_all",
  HIDE = "hide",
  UN_HIDE = "unHide",
  EDIT = "edit",
  REMOVE = "remove",
  ADD = "add",
  ADD_NEW_GROUP = "add_new_group",
}
export enum FavoriteTypeEnum {
  BOARD = "board",
  TICKET = "ticket",
}

export interface BoardsState {
  boardsData: Board[];
  boardsForm: IBoardForm;
  favorites: Board[];
  qaBoards: Board[];
  recent: Board[];
  defaultTicketValueData: IDefaultTicketValueData;
  draftTicket: IDraftTicket[];
  selectedTickets: ISelectedTickets;
  isFileUploading: boolean;
  isFilePreview: boolean;
  uploadProgress: number;
  sortByColumn: string;
  sortByOrder: string;
  isLoading: boolean;
  isBulkExporting: boolean;
  selectedBoard: IBoard[];
  boardLoading: boolean;
  enableTicketDescription: boolean;
  enableAddNewTemplateForm: boolean;
}
